{
  "w": 8,
  "h": 12,
  "rows": [
    "........",
    ".YYWWYYY",
    ".YYYYYYY",
    "....R...",
    "YYYYYYYY",
    "YYYYYYYY",
    "....R...",
    "....R...",
    "....R...",
    "....R...",
    "....R...",
    "...WWW.."
  ],
  "legend": {
    "R": "C.RED",
    "Y": "C.B_YELLOW",
    "W": "C.B_WHITE"
  }
}
